<h1 class="text-2xl font-medium"
    [ngClass]="{
      'mb-2': marginStyle() === 'small',
      'mb-4': marginStyle() === 'regular',
      'text-center': center(),
    }"
>{{title()}}</h1>
